<template>
    <div class="enps-resolution-chart">
        <div class="enps-resolution-chart__title">Оценка и срок решения</div>
        <div class="enps-chart-placeholder" v-if="!hasData" style="height: 220px">Нет оценок за период</div>
        <Bar v-else :chart-data="chartData" :chart-options="chartOptions" :styles="chartStyles"></Bar>
    </div>
</template>
<script>
import { Bar } from 'vue-chartjs/legacy';
import { ratingScaleColor } from '@/js/enpsColors';

// pt.6: средняя оценка по бакетам времени решения (создание -> закрытие обращения). Подпись
// с числом оценок печатается прямо на тике оси X (второй строкой), а не только по ховеру —
// так число видно сразу, без необходимости наводить курсор. Собственная карточка (заголовок +
// фиксированная высота 220px), как у EnpsMonthlyTrendChart.vue — этот график остаётся
// отдельной метрикой и не объединяется с динамикой по месяцам.
export default {
    components: {
        Bar,
    },
    props: {
        buckets: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            chartStyles: {
                height: '220px',
                position: 'relative',
            },
        };
    },
    computed: {
        hasData() {
            return this.buckets.some((bucket) => bucket.ratingsCount > 0);
        },
        chartData() {
            return {
                labels: this.buckets.map((bucket) => [bucket.label, `(${bucket.ratingsCount} оценок)`]),
                datasets: [
                    {
                        label: 'Средняя оценка',
                        data: this.buckets.map((bucket) => bucket.averageRating),
                        // Цвет столбца — строго по значению (единая шкала >4 / 3-4 / <3 из
                        // enpsColors.js, одна на все столбчатые графики); бакет без оценок
                        // отдаёт null и красится нейтральным.
                        backgroundColor: this.buckets.map((bucket) => ratingScaleColor(bucket.averageRating)),
                    },
                ],
            };
        },
        chartOptions() {
            const buckets = this.buckets;

            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label(context) {
                                const bucket = buckets[context.dataIndex];

                                return `Средняя: ${bucket.averageRating ?? '—'}, оценок: ${bucket.ratingsCount}`;
                            },
                        },
                    },
                },
                scales: {
                    y: { min: 0, max: 5 },
                },
            };
        },
    },
};
</script>
<style lang="scss">
.enps-resolution-chart {
    flex: 1;
    padding: 15px;
    border-radius: 8px;
    background-color: var(--color-white);
    box-shadow: 0px 1px 10px rgba(88, 88, 88, 0.15);

    &__title {
        margin-bottom: 10px;
        font-weight: 600;
    }
}

.enps-chart-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a0a0a0;
}
</style>
